import helpers from '../../helpers';
import api from '../api';
import productTons from '../../product-tons';

export default {
  state: {
    price: 0,
    weight: 0,
    nutritionalInfo: {
      'pc': 0,
      'em': 0,
      'cne': 0,
      'ee': 0,
      'fdn': 0,
      'ct': 0,
      'fc': 0,
      'ms': 0,
    },
    ingredientsProportion: {},
    ingredientIdsByName: {},
    type: '',
    details: null,
    selectedTons: 15,
    finishing: {
      form: { value: 'powder', label: helpers.translate('powder') },
      packaging: { value: 'bulk', label: helpers.translate('bulk') },
      totalSackWeight: null,
    },
    dailyWeightRequirement: null,
    updated: false,
  },
  mutations: {
    updateRecipe: (state, payload) => {
      state.price = payload.price;
      state.weight = payload.weight;
      state.nutritionalInfo = payload.nutritional_info;
      state.ingredientsProportion = Object.assign({}, ...payload.ingredients_proportion);
      state.ingredientIdsByName = (payload.verbose_ingredients_proportion || []).reduce((idsByName, ingredient) => {
        idsByName[ingredient.name] = ingredient.id;
        return idsByName;
      }, {});
    },
    updateProductInformation: (state, payload) => {
      const ton = 1000;
      const selectedTons = productTons.positiveTons(payload.selected_tons, payload.unit_tons || 15);
      state.price = payload.kilogram_price;
      state.weight = selectedTons * ton;
      state.type = 'product';
      state.selectedTons = selectedTons;
      state.ingredientIdsByName = {};
      state.details = {};
      state.details.name = payload.name;
      state.details.description = payload.description;
      state.details.id = payload.id;
      state.details.category = payload.category;
      payload.product_ingredients.forEach(ingredient => {
        state.ingredientsProportion[ingredient.name] = ingredient.percentage;
        state.ingredientIdsByName[ingredient.name] = ingredient.id;
      });
    },
    updateProductIngredient: (state, payload) => {
      state.nutritionalInfo.pc = payload.pc;
      state.nutritionalInfo.em = payload.em;
      state.nutritionalInfo.cne = payload.cne;
      state.nutritionalInfo.ee = payload.ee;
      state.nutritionalInfo.fdn = payload.fdn;
      state.nutritionalInfo.ct = payload.ct;
      state.nutritionalInfo.fc = payload.fc;
      state.nutritionalInfo.ms = payload.ms;
    },
    updateForm: (state, payload) => { state.finishing.form = payload; },
    updatePackaging: (state, payload) => { state.finishing.packaging = payload; },
    updateTotalSackWeight: (state, payload) => { state.finishing.totalSackWeight = payload; },
    setUpdated: (state, payload) => { state.updated = payload; },
    updateType: (state, payload) => { state.type = payload; },
    updateDailyWeightRequirement: (state, payload) => { state.dailyWeightRequirement = payload; },
  },
  actions: {
    cheapestRecipe: (context, payload) => {
      const params = { ...payload };
      if (context.rootState.order.isColunWeb) params.tenant = 'colun';
      else if (context.rootState.order.isCoagraWeb) params.tenant = 'coagra';
      return api.cheapestRecipe(params)
        .then((recipe) => context.dispatch('saveFormulaRecipe', recipe))
        .catch((e) => {
          context.commit('setUpdated', false);
          throw e;
        });
    },
    inverseRecipe: (context, { ingredients, nutritionalInfo = null }) => {
      const formState = context.state.finishing.form;
      const packagingState = context.state.finishing.packaging;
      const form = typeof formState === 'string' ? formState : formState?.value;
      const packaging = typeof packagingState === 'string' ? packagingState : packagingState?.value;
      let tenant = null;
      if (context.rootState.order.isColunWeb) tenant = 'colun';
      else if (context.rootState.order.isCoagraWeb) tenant = 'coagra';

      api.inverseRecipe(ingredients, form, packaging,
        context.state.finishing.totalSackWeight, nutritionalInfo, tenant)
        .then((recipe) => {
          context.dispatch('saveFormulaRecipe', recipe);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updateDailyWeightRequirement: (context, payload) => {
      context.commit('updateDailyWeightRequirement', payload);
    },
    saveFormulaRecipe: (context, recipe) => {
      context.commit('updateType', 'formula');
      context.commit('updateRecipe', recipe);
      context.commit('setUpdated', true);
    },
  },
};
